import { useEffect } from "react";
import { useAuth } from "./AuthContext";

const GlobalInterceptor: React.FC = () => {
  const { isLoggedIn, setShowLoginModal } = useAuth();

  useEffect(() => {
    const handleClick = (e: MouseEvent) => {
      const target = (e.target as HTMLElement)?.closest<HTMLElement>(
        'button, [role="menuitem"], [role="button"], a, [data-requires-auth]'
      );
      // ✅ Allow anything inside login modal to pass through
      if (
        target?.closest(".ant-modal") || // native AntD modal container
        target?.closest(".ant-dropdown") ||
        target?.closest(".login-modal") ||
        target?.closest(".ant-menu-submenu") ||
        target?.closest('[role="dialog"]') // accessibility-safe
      ) {
        return; // allow internal modal clicks
      }
      const actionable = target?.closest<HTMLElement>(
        'button, [role="menuitem"], [role="button"], a, [data-requires-auth]'
      );
      if (!actionable) return;

      // ✅ Allow public buttons
      if (actionable.hasAttribute("data-no-auth")) return;

      if (!isLoggedIn) {
        e.preventDefault();
        e.stopPropagation(); // still blocks original click
        setShowLoginModal(true);
      }
    };

    document.addEventListener("click", handleClick, true); // capture phase

    return () => {
      document.removeEventListener("click", handleClick, true);
    };
  }, [isLoggedIn, setShowLoginModal]);

  return null;
};

export default GlobalInterceptor;
